import { render, staticRenderFns } from "./ServiceOverview.vue?vue&type=template&id=399e2f3f&scoped=true&"
import script from "./ServiceOverview.vue?vue&type=script&lang=js&"
export * from "./ServiceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399e2f3f",
  null
  
)

export default component.exports